import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ORIGIN = 'https://marketscan.tech';
const publicPages = {
  '/': { title: 'AI Competitor Analysis & Market Research Software | Market Scan', description: 'Research competitors, pricing history, customer sentiment, SEO signals, and market trends with Market Scan\'s AI competitor analysis software.', canonical: `${ORIGIN}/`, image: `${ORIGIN}/og-image.png`, schema: true },
  '/privacy': { title: 'Privacy Policy | Market Scan', description: 'Learn how Market Scan collects, uses, and protects information, including Google Ads measurement and your privacy choices.', canonical: `${ORIGIN}/privacy` },
  '/terms': { title: 'Terms of Service | Market Scan', description: 'Read the terms governing use of Market Scan market research software and services.', canonical: `${ORIGIN}/terms` },
};

export default function SeoManager() {
  const { pathname } = useLocation();
  useEffect(() => {
    const config = publicPages[pathname];
    const title = config?.title || (pathname === '/404' ? 'Page Not Found | Market Scan' : 'Market Scan');
    document.title = title;
    setMeta('description', config?.description || 'Market Scan account and application page.');
    setMeta('robots', config ? 'index, follow' : 'noindex, nofollow');
    setMeta('og:title', title, 'property');
    setMeta('og:description', config?.description || '', 'property');
    setMeta('og:url', config?.canonical || `${ORIGIN}${pathname}`, 'property');
    setMeta('og:image', config?.image || `${ORIGIN}/og-image.png`, 'property');
    setMeta('twitter:title', title);
    setMeta('twitter:description', config?.description || '');
    setLink('canonical', config?.canonical || `${ORIGIN}${pathname}`);

    document.querySelectorAll('script[data-marketscan-schema]').forEach((node) => node.remove());
    if (config?.schema) {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.dataset.marketscanSchema = 'true';
      script.text = JSON.stringify({ '@context': 'https://schema.org', '@type': 'SoftwareApplication', name: 'Market Scan', url: `${ORIGIN}/`, applicationCategory: 'BusinessApplication', operatingSystem: 'Web', description: config.description, publisher: { '@type': 'Organization', name: 'PDX Intelligence', url: 'https://pdxintelligence.com/' } });
      document.head.appendChild(script);
    }
  }, [pathname]);
  return null;
}

function setMeta(name, content, attribute = 'name') { let node = document.head.querySelector(`meta[${attribute}="${name}"]`); if (!node) { node = document.createElement('meta'); node.setAttribute(attribute, name); document.head.appendChild(node); } node.content = content; }
function setLink(rel, href) { let node = document.head.querySelector(`link[rel="${rel}"]`); if (!node) { node = document.createElement('link'); node.rel = rel; document.head.appendChild(node); } node.href = href; }
